import React from "react";
import { Controller } from "react-hook-form";
import Input from "../../../../components/input";
import FIlterSelect from "../../../../components/filter-select";
import Textarea from "../../../../components/textarea";

interface ProductDetailsProps {
  control: any;
  clearErrors: any;
  errors: any;
  hasVariants: boolean;
  setHasVariants: (value: boolean) => void;
  information?: any;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({
  control,
  hasVariants,
  setHasVariants,
  information,
}) => {
  return (
    <>
      <div className="flex justify-between items-center">
        <p className="text-[#2B2B2B]">Does This Product have Variants?</p>
        <div className="relative inline-block w-10 h-5 rounded-full">
          <input
            type="checkbox"
            className="peer sr-only"
            checked={hasVariants}
            onChange={(e) => setHasVariants(e.target.checked)}
            id="hasVariantsToggle"
          />
          <label
            htmlFor="hasVariantsToggle"
            className={`absolute top-0 left-0 right-0 bottom-0 cursor-pointer rounded-full transition-all duration-200 ${
              hasVariants ? "bg-green-500" : "bg-gray-300"
            }`}
          >
            <span
              className={`absolute top-0.5 left-0.5 bg-white w-4 h-4 rounded-full transition-all duration-200 ${
                hasVariants ? "translate-x-5" : ""
              }`}
            />
          </label>
        </div>
      </div>

      <Controller
        name="name"
        control={control}
        defaultValue={information?.name}
        rules={{
          required: "Product Name is required",
        }}
        render={({ field, fieldState }) => (
          <Input
            value={field.value || ""}
            className="w-full"
            label="Name"
            placeholder="Enter Product Name"
            error={fieldState?.error?.message}
            onChange={field.onChange}
          />
        )}
      />

      <Controller
        name="category"
        control={control}
        defaultValue={information?.category}
        rules={{
          required: "Category is required",
        }}
        render={({ field }) => (
          <FIlterSelect
            name="category"
            options={[
              { value: "", label: "Select category" },
              { value: "premium", label: "Premium" },
              { value: "gold", label: "Gold" },
            ]}
            className="w-full"
            label="Category"
            onChange={(selectedValue) => {
              field.onChange(selectedValue);
            }}
            value={field.value}
          />
        )}
      />

      <Controller
        name="description"
        control={control}
        defaultValue={information?.description}
        rules={{
          required: "Description is required",
        }}
        render={({ field, fieldState }) => (
          <Textarea
            value={field.value || ""}
            className="w-full"
            label="Description"
            placeholder="Add item description"
            error={fieldState?.error?.message}
            onChange={field.onChange}
          />
        )}
      />

      <Controller
        name="measurementUnit"
        control={control}
        defaultValue={information?.measurementUnit}
        rules={{
          required: "Unit of Measurement is required",
        }}
        render={({ field }) => (
          <FIlterSelect
            name="unit"
            options={[
              { value: "", label: "Select or type to add" },
              { value: "kg", label: "kg" },
              { value: "g", label: "g" },
              { value: "lbs", label: "lbs" },
              { value: "pieces", label: "pieces" },
            ]}
            className="w-full"
            label="Unit of Measurement"
            onChange={field.onChange}
            value={field.value}
          />
        )}
      />

      <Controller
        name="quantity"
        control={control}
        defaultValue={information?.quantity}
        rules={{
          required: "Quantity is required",
        }}
        render={({ field, fieldState }) => (
          <Input
            value={field.value || ""}
            className="w-full"
            label="Quantity"
            placeholder="Enter item quantity"
            type="number"
            error={fieldState?.error?.message}
            onChange={field.onChange}
          />
        )}
      />

      {!hasVariants && (
        <>
          <Controller
            name="reorderLevel"
            control={control}
            defaultValue={information?.reorderLevel}
            render={({ field }) => (
              <Input
                value={field.value || ""}
                className="w-full"
                label="Reorder Level"
                placeholder="Enter item reorder level"
                type="number"
                onChange={field.onChange}
              />
            )}
          />

          <div className="flex items-center mt-4 border rounded-full h-[48px]  border-[#9D9898]">
            <div className="w-14 ">
              <span className="block text-sm">Price</span>
              <div className=" px-3 h-[45px] pt-2.5 mb-5 rounded-l-full text-center bg-gray-100">
                ₦
              </div>
            </div>
            <div className="flex-1">
              <Controller
                name="price"
                control={control}
                defaultValue={information?.price}
                rules={{
                  required: !hasVariants ? "Price is required" : false,
                }}
                render={({ field, fieldState }) => (
                  <input
                    value={field.value || ""}
                    className="w-full rounded-r-full outline-none h-[40px]"
                    placeholder="Enter sales price to customer"
                    type="number"
                    onChange={field.onChange}
                  />
                )}
              />
            </div>
            <div className="w-20">
              <span className="block text-sm">&nbsp;</span>
              <select className="rounded-r-full h-[45px]  mb-5 bg-gray-100 px-3 w-full">
                <option>Naira</option>
              </select>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductDetails;
